import use24Actions from '@/composables/actions/use24Actions.js'
import use561Actions from '@/composables/actions/use561Actions'
import use713Actions from '@/composables/actions/use713Actions'
import use148Actions from '@/composables/actions/use148Actions'
import useIssueVisaActions from '@/composables/actions/useIssueVisaActions'
import { useFormStore } from '@/stores/form'

const selectModuleChange = () => {
  const formStore = useFormStore()
  const { fileModuleId } = formStore.form.values
  formStore.extraMap.disableCardReader = fileModuleId == 1
  formStore.form.setFieldValue('isUsingCardReader', true)
}
export default function () {
  return {
    selectIdentificater: useIssueVisaActions().selectIdentificater,
    changePersonPhotoFlagAction: use561Actions('changePersonPhotoFlagAction'),
    selectIsStillMarried: () => use713Actions('selectIsStillMarried'),
    selectIsFatherWorking: () => use713Actions('selectIsFatherWorking'),
    resetWarnings: () => use24Actions().resetWarnings(),
    establishmentTypeChange: () => use148Actions().establishmentTypeChange(),
    selectModuleChange
  }
}
